<template>
<div class="chapter">
<div class="inner_page">
<section class="chapter" epub:type="chapter" id="ser_1" role="doc-chapter">
<p class="sert" style="text-align:center;"><span aria-label="v" class="page" id="pv" role="doc-pagebreak"></span>The Collected Works of F. A. Hayek</p>
<p class="serf" style="text-align:center;">Founding Editor: W. W. Bartley III</p>
<p class="ser" style="text-align:center;">General Editor: Bruce Caldwell</p>
<p class="serpf" style="text-align:center;"><i>Published with the support of</i></p>
<p class="serf" style="text-align:center;">The Hoover Institution on War, Revolution and PeaceStanford University</p>
<p class="ser" style="text-align:center;">The Cato Institute</p>
<p class="ser" style="text-align:center;">The Earhart Foundation</p>
<p class="ser" style="text-align:center;">The Pierre F. and Enid Goodrich Foundation</p>
<p class="ser" style="text-align:center;">The Heritage Foundation</p>
<p class="ser" style="text-align:center;">The Morris Foundation, Little Rock</p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chi-hayek-vol19-0006.vue?2cc5dbc3